var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3181_1803)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3181_1803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.25C15.1826 24.25 18.2348 22.9857 20.4853 20.7353C22.7357 18.4848 24 15.4326 24 12.25C24 9.0674 22.7357 6.01516 20.4853 3.76472C18.2348 1.51428 15.1826 0.25 12 0.25C8.8174 0.25 5.76516 1.51428 3.51472 3.76472C1.26428 6.01516 0 9.0674 0 12.25C0 15.4326 1.26428 18.4848 3.51472 20.7353C5.76516 22.9857 8.8174 24.25 12 24.25Z",
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3181_1803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3181_1803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackInactive);
export default __webpack_public_path__ + "static/media/track-inactive.628e3eb2b80d8444f880d07ed65de74a.svg";
export { ForwardRef as ReactComponent };